import { render, staticRenderFns } from "./TestKitSpread.vue?vue&type=template&id=81cb7a64&scoped=true&"
import script from "./TestKitSpread.vue?vue&type=script&lang=js&"
export * from "./TestKitSpread.vue?vue&type=script&lang=js&"
import style0 from "./TestKitSpread.vue?vue&type=style&index=0&id=81cb7a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb7a64",
  null
  
)

export default component.exports